import { render, staticRenderFns } from "./RoutesTooltipWithIcon.vue?vue&type=template&id=562768fd&"
import script from "./RoutesTooltipWithIcon.vue?vue&type=script&lang=js&"
export * from "./RoutesTooltipWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports